import { createSlice } from '@reduxjs/toolkit';
import { fetchCourse } from './thunks/fetchCourseThunk';

const courseSlice = createSlice({
  name: 'course',
  initialState: {
    data: null,
    error: null,
    loading: false,
  },
  reducers: {
    resetCourseData: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourse.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCourse.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCourseData } = courseSlice.actions;
export default courseSlice.reducer;
